import { environment } from '../../../environments/environment';
import { IAuthRepository } from '../../domain/auth/i-auth-repository';
import { IBulkRepository } from '../../domain/bulk/i-bulk-repository';
import { IConversationsRepository } from '../../domain/conversations/i-conversations-repository';
import { IEventsRepository } from '../../domain/events/i-events-repository';
import { IToastController } from '../../domain/global/i-toast-controller';
import { IMediaRepository } from '../../domain/media/i-media-repository';
import { IPhoneNumbersRepository } from '../../domain/phone-numbers/i-phone-numbers-repository';
import { ISessionRepository } from '../../domain/session/i-session-repository';
import { IStorageRepository } from '../../domain/storage';
import { ITemplatesRepository } from '../../domain/templates/i-templates-repository';
import { FakeAuthRepository } from '../fake/auth-repository';
import { FakeBulkRepository } from '../fake/bulk.repository';
import { FakeConversationsRepository } from '../fake/conversations.repository';
import { FakeEventsRepository } from '../fake/events.repository';
import { FakeMediaRepository } from '../fake/media.repository';
import { FakePhoneNumbersRepository } from '../fake/phone-numbers.repository';
import { FakeSessionRepository } from '../fake/session-repository';
import { FakeTemplatesRepository } from '../fake/templates.repository';
import { RealAuthRepository } from '../real/auth/auth-repository';
import { RealBulkRepository } from '../real/bulk/bulk.repository';
import { RealConversationsRepository } from '../real/conversations/conversations.repository';
import { RealEventsRepository } from '../real/events/events.repository';
import { ToastController } from '../real/global/toast-controller-repository';
import { RealMediaRepository } from '../real/media/media.repository';
import { RealPhoneNumbersRepository } from '../real/phone-numbers/phone-numbers.repository';
import { SessionRepository } from '../real/session/session-repository';
import { StorageRepository } from '../real/storage/storage-repository';
import { RealTemplatesRepository } from '../real/templates/templates.repository';
import { HttpClient } from '../services/httpClient/httpClient';
import { IHttpClient } from '../services/httpClient/interface';

const provider = environment.provider;
const isFake = provider === 'fake';

export const storageProvider = {
  provide: IStorageRepository,
  useClass: StorageRepository,
};

const httpClientProvider = {
  provide: IHttpClient,
  useClass: HttpClient,
};

const toastControllerProvider = {
  provide: IToastController,
  useExisting: ToastController,
};

export const sessionProvider = {
  provide: ISessionRepository,
  useClass: isFake ? FakeSessionRepository : SessionRepository,
};

export const authRepositoryProvider = {
  provide: IAuthRepository,
  useClass: isFake ? FakeAuthRepository : RealAuthRepository,
};

export const phoneNumbersRepositoryProvider = {
  provide: IPhoneNumbersRepository,
  useClass: isFake ? FakePhoneNumbersRepository : RealPhoneNumbersRepository,
};

export const conversationsRepositoryProvider = {
  provide: IConversationsRepository,
  useClass: isFake ? FakeConversationsRepository : RealConversationsRepository,
};

export const templatesRepositoryProvider = {
  provide: ITemplatesRepository,
  useClass: isFake ? FakeTemplatesRepository : RealTemplatesRepository,
};

export const bulkRepositoryProvider = {
  provide: IBulkRepository,
  useClass: isFake ? FakeBulkRepository : RealBulkRepository,
};

export const eventsRepositoryProvider = {
  provide: IEventsRepository,
  useClass: isFake ? FakeEventsRepository : RealEventsRepository,
};

export const mediaRepositoryProvider = {
  provide: IMediaRepository,
  useClass: isFake ? FakeMediaRepository : RealMediaRepository,
};

const commonProviders = [
  storageProvider,
  httpClientProvider,
  ToastController,
  toastControllerProvider,
  sessionProvider,
  authRepositoryProvider,
  phoneNumbersRepositoryProvider,
  conversationsRepositoryProvider,
  templatesRepositoryProvider,
  bulkRepositoryProvider,
  eventsRepositoryProvider,
  mediaRepositoryProvider,
];

export const providers = [...commonProviders];
